import { MediaWidget } from '../types'

interface Props {
  instance: MediaWidget
}

export const DashboardVideo = ({ instance }: Props) => {
  return (
    <iframe
      title={instance.title}
      width="100%"
      height="375"
      src={instance.media_url}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
}
